<template>
  <div>
    <div v-if="isLoading" class="text-center">
      <b-spinner variant="primary"></b-spinner>
    </div>
    <b-form @submit.prevent="submit" v-if="!isLoading">
      <b-row>
        <b-col cols="12">
          <editor dir="rtl" v-model="title_description">
            <br />
          </editor>
        </b-col>
        <b-col cols="12" v-if="mode == `edit`">
          <b-form-group
            :label="$lang.azmoonLang.type"
            label-for="is_enable"
            :label-cols="12"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.status"
              :rules="$v.is_enable.$params"
            />
            <b-form-radio-group
              id="is_enable"
              :autocomplete="$lang.azmoonLang.status"
              v-model="$v.is_enable.$model"
              :state="$v.is_enable.$dirty ? !$v.is_enable.$error : null"
              :options="is_enable_options"
              buttons
              button-variant="outline-primary"
              size="md"
              name="radio-btn-outline"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12">
          <div class="form-group form-btn text-right">
            <b-button
              v-if="isAdmin(permissions)"
              type="submit"
              size="md"
              variant="success"
            >
              {{ $lang.azmoonLang.submitButton }}
              <i class="fa fa-check"></i>
            </b-button>
            <b-button
              class="ml-2"
              size="md"
              variant="danger"
              @click="handleBack"
            >
              {{ $lang.azmoonLang.cancelButton }}
              <i class="fa fa-ban"></i>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import editor from "@/components/ckeditor/editor";
import { isAdmin } from "@/shared/utils";
import { createPureDom } from "@/shared/utils";
export default {
  name: "title-from",
  validations: {
    title_description: {},
    is_enable: {},
  },
  components: {
    editor,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "",
    },
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      is_enable_options: [],
      title_description: null,
      is_enable: 1,
    };
  },
  methods: {
    isAdmin,
    createPureDom,
    handleBack() {
      this.$emit("cancel");
    },
    getValue() {
      let values;

      values = [
        {
          value: 1,
          text: "فعال",
        },
        {
          value: 0,
          text: "غیرفعال",
        },
      ];

      this.is_enable_options = values;
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      let payload = {
        is_enable: this.is_enable,
        title_description: this.title_description,
      };
      this.$emit("submit", payload);
    },
    fetchData() {
      if (this.item && Object.keys(this.item).length > 0) {
        this.is_enable = this.item.is_enable;
        this.title_description = createPureDom(this.item.title_description);
      }
    },
  },
  created() {
    this.getValue();
    this.fetchData();
  },
};
</script>

<style></style>
